import { render, staticRenderFns } from "./SurveyRecipients.vue?vue&type=template&id=5ba0ad2b"
import script from "./SurveyRecipients.vue?vue&type=script&lang=js"
export * from "./SurveyRecipients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports